import React, { useEffect, useState } from "react";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { toISOString } from "../../../utils/functions/date-utils";
import { toast } from "react-toastify";
import {
  useCreateNotificaMutation,
  useDeleteNotificaMutation,
  useEditNotificaMutation,
} from "../../api/admin/notificheApi";
import { t } from "i18next";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton } from "@mui/material";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";

const CreateNotifica = ({ handleClose, create, studioId, notifica }) => {
  const [validationErrors, setValidationErrors] = useState({});
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    notifyAt: create?.dateStr,
    url: "",
    description: "",
    studioId: studioId || null,
  });
  const [createNotifica, { isLoading }] = useCreateNotificaMutation();
  const [editNotifica, { isLoading: isLoadingEdit }] =
    useEditNotificaMutation();
  const [deleteNotifica, { isLoading: isLoadingDelete }] =
    useDeleteNotificaMutation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (notifica) {
      setFormData({
        id: notifica.event.id,
        title: notifica.event.title,
        notifyAt: toISOString(notifica.event.start).split("T")[0],
        url: notifica.event.url,
        description: notifica.event.extendedProps.description,
      });
    }
  }, [notifica]);

  const handleSave = () => {
    setValidationErrors({});
    const errors = {};
    if (!formData.title) errors.title = t("FieldRequired");
    if (!formData.notifyAt) errors.notifyAt = t("FieldRequired");
    if (!formData.description) errors.description = t("FieldRequired");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    if (!notifica) {
      createNotifica({ ...formData, notifyAt: toISOString(formData.notifyAt) })
        .unwrap()
        .then((res) => {
          if (res.Result !== 1) {
            toast.error(res.Exception || t("NotifyNotCreated"));
            return;
          }
          toast.success(t("NotifyCreated"));
          handleClose();
        })
        .catch(() => {
          t("NotifyNotCreated");
        });
    }

    if (notifica) {
      editNotifica({
        ...formData,
        notifyAt: toISOString(formData.notifyAt),
        studioId: studioId,
      })
        .unwrap()
        .then((res) => {
          if (res.Exception) {
            toast.error(res.Exception);
          } else {
            toast.success(t("DeadlineUpdated"));
            handleClose();
          }
        })
        .catch(() => {
          toast.error(t("DeadlineNotUpdated"));
        });
    }
  };

  const handleDeleteNotifica = () => {
    deleteNotifica({ id: notifica.event.id })
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else {
          toast.success(t("DeadlineDeleted"));
          handleClose();
        }
      })
      .catch(() => {
        toast.error(t("DeadlineNotDeleted"));
      });
  };

  const handleCloseDialod = () => {
    setShowConfirmDeleteDialog(false);
  };

  const handleOpenDialod = () => {
    setShowConfirmDeleteDialog(true);
  };

  return (
    <div className="w-full p-4 flex flex-col items-center ">
      <div className="w-full flex justify-between items-center ">
        <div></div>
        <h3>{notifica ? t("UpdateDeadline") : t("CreateDeadline")}</h3>
        <div>
          <IconButton onClick={handleClose} disabled={isLoading}>
            <CloseRoundedIcon className="text-red-600" />
          </IconButton>
        </div>
      </div>
      <div className="w-2/3">
        <div>
          <CoreInputField
            label={t("Title")}
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            fullWidth
            required
            error={Boolean(validationErrors.title)}
            helperText={validationErrors.title}
          />
        </div>
        <div>
          <CoreInputField
            type="date"
            name="notifyAt"
            value={formData.notifyAt}
            onChange={handleInputChange}
            fullWidth
            required
            error={Boolean(validationErrors.notifyAt)}
            helperText={validationErrors.notifyAt}
          />
        </div>
        <div>
          <CoreInputField
            label={t("Description")}
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            fullWidth
            id="outlined-multiline-static"
            multiline
            rows={5}
            required
            error={Boolean(validationErrors.description)}
            helperText={validationErrors.description}
          />
        </div>
        <div className="py-5 flex justify-center space-x-4">
          {notifica && (
            <CoreButton
              className={"btn-round bg-red-700 btn-round border-red-700"}
              variant="contained"
              testo={t("Delete")}
              onClick={handleOpenDialod}
              disabled={isLoadingDelete || isLoadingEdit}
            />
          )}
          <CoreButton
            className={"btn-round"}
            variant="contained"
            testo={t("Save")}
            onClick={handleSave}
            disabled={isLoading}
          />
        </div>
      </div>
      <CoreDialog
        open={showConfirmDeleteDialog}
        title={`${t("Delete")} ${t("deadline")}`}
        content={`${t("DeadlineDeletingConfirm")} "${notifica?.event.title}"`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleDeleteNotifica}
        closeDialog={handleCloseDialod}
      />
    </div>
  );
};

export default CreateNotifica;
